"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconChevronDown = function IconChevronDown(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconChevronDown', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 7.466L3.428 4.241a.561.561 0 0 0-.82 0 .631.631 0 0 0 0 .862L6.09 8.759a.561.561 0 0 0 .82 0l3.483-3.656a.631.631 0 0 0 0-.862.561.561 0 0 0-.821 0L6.5 7.466z"
  }));
};

var _default = IconChevronDown;
exports.default = _default;